import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/networkBeaconDelete";
import { showErrorMessage } from "tools/apiErrorsHelper";

function* networkBeaconDelete(action) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "delete",
      `networks/${action.payload.networkId}/beacons/${action.payload.beaconId}`
    );
    if (action.resolve) {
      yield call(action.resolve, response.data, action.payload);
    }
    yield put(actions.requestSuccess(response.data, action.payload));
  } catch (error) {
    showErrorMessage(error);
    if (action.reject) {
      yield call(action.reject, error, action.payload);
    }
    yield put(actions.requestFailure(error, action.payload));
  }
}

function* saga() {
  yield takeEvery(actions.NETWORK_BEACON_DELETE_REQUEST, networkBeaconDelete);
}

export default saga;
